import React from 'react';
import Chip from '@mui/material/Chip';

import { NO_REFERENCE_LABEL } from './noReferenceComparisons';

function NoReferenceBadge({ sx }) {
  return (
    <Chip
      label={NO_REFERENCE_LABEL}
      size="small"
      color="warning"
      variant="outlined"
      sx={{
        maxWidth: '100%',
        height: 'auto',
        '& .MuiChip-label': {
          whiteSpace: 'normal',
          lineHeight: 1.2,
          py: 0.25
        },
        ...sx
      }}
    />
  );
}

export default NoReferenceBadge;
